import React from 'react';
import { contactData } from '../data/mock';

const Header = () => {
  return (
    <header className="editorial-header">
      <div className="container">
        <nav className="editorial-nav">
          <a href="/" className="editorial-logo">
            <div className="logo-mark">M</div>
            <span className="logo-text">MEERASHI</span>
          </a>

          <ul className="editorial-menu">
            <li><a href="#work" className="editorial-nav-link">Work</a></li>
            <li><a href="#about" className="editorial-nav-link">About</a></li>
            <li><a href="#contact" className="editorial-nav-link">Contact</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
